import { FC } from 'react';
import moment from 'moment';

import DefaultModal from 'components/Modals/DefaultModal';
import CommonButton from 'components/CommonButton/CommonButton';

import { WorkingHour } from 'interfaces/clinicSchedule';
import useModal from 'hooks/useModal';
import { groupBy, sortBy } from 'lodash';
import { DATE_TIME_FORMAT } from 'utils/datetime';

interface SyncedScheduleModalProps {
  selectedDate: {
    date: string;
    workingHour: string | WorkingHour[];
  };
  isClinicOff: boolean;
  isPractitionerOff: boolean;
  onClose: () => void;
}

const SyncedScheduleModal: FC<SyncedScheduleModalProps> = ({
  selectedDate,
  isClinicOff,
  isPractitionerOff,
  onClose,
}) => {
  useModal({ onClose });

  const renderWorkingHours = () => {
    if (Array.isArray(selectedDate.workingHour)) {
      const groupByOpId = groupBy(selectedDate.workingHour, 'operatoryId');

      return Object.keys(groupByOpId).map((operatoryId) => {
        const workingHours = groupByOpId[operatoryId];

        const sortedByStartTime = sortBy(workingHours, (item) =>
          moment(item.start, DATE_TIME_FORMAT.HH_MM_SS).valueOf()
        );

        return (
          <div className="flex mt-1.5 ">
            <span className="text-13 leading-[2rem] w-full max-w-[180px] text-dim-grey font-bold">
              {groupByOpId[operatoryId]?.[0]?.operatoryName || ''}
            </span>
            <div className="ml-5">
              {sortedByStartTime.map((item) => {
                const startTime = moment(item.start, 'HH:mm:ss').format(
                  'hh:mmA'
                );

                const endTime = moment(item.end, 'HH:mm:ss').format('hh:mmA');

                return (
                  <div className="mb-[4px]">{`${startTime}-${endTime}`}</div>
                );
              })}
            </div>
          </div>
        );
      });
    }
  };

  const renderType = () => {
    if (isClinicOff) {
      return 'Office Closed';
    } else if (isPractitionerOff) {
      return 'Day Off';
    }

    return 'Working Day';
  };

  return (
    <DefaultModal className="top-[45%]">
      <div className="w-[480px] min-h-[290px] p-2 text-14 leading-[2.1rem] text-darkest-grey relative flex flex-col">
        <h3 className="text-16 leading-[2.4rem] font-bold">PMS Availability</h3>
        <div className="flex items-center mt-1.5 ">
          <span className="text-13 leading-[2rem] w-full max-w-[180px] text-dim-grey font-bold">
            Type
          </span>
          <div className="flex-1 w-full ml-5">{renderType()}</div>
        </div>

        <div className="flex items-center mt-1.5 ">
          <span className="text-13 leading-[2rem] w-full max-w-[180px] text-dim-grey font-bold">
            Date
          </span>
          <div className="flex-1 w-full ml-5">
            {moment(
              selectedDate.date,
              DATE_TIME_FORMAT.APPOINTMENT_DATE
            ).format('MMMM DD, YYYY')}
          </div>
        </div>
        {renderWorkingHours()}

        <div className="flex gap-x-1.6 justify-end mt-auto pt-[28px]">
          <CommonButton
            variant="secondary"
            className="!min-w-[13rem] !min-h-[3.2rem]"
            onClick={onClose}
          >
            Cancel
          </CommonButton>
        </div>
      </div>
    </DefaultModal>
  );
};

export default SyncedScheduleModal;
